import { HIDE_MODAL, SHOW_MODAL } from './constants';
import { combineReducers } from 'redux';

import { LOCATION_CHANGE } from 'react-router-redux/reducer';

const modalType = (state = null, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return action.modalType || null;
        case LOCATION_CHANGE:
        case HIDE_MODAL:
            return null;
        default:
            return state;
    }
};

const modalProps = (state = null, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return action.modalProps || null;
        case LOCATION_CHANGE:
        case HIDE_MODAL:
            return null;
        default:
            return state;
    }
};

export default combineReducers({ modalType, modalProps });



// WEBPACK FOOTER //
// ./src/services/modal/reducer.js